<template>
    <div class="main">
        <div class="transaction-list">
            <div class="row">
                <div class="container">
                    <h3 class="title">MIS Bills </h3>
                    <div class="form-group">
                        <label for="applicant">Applicant:</label>
                        <v-select v-model="formData.applicantid" :options="applicants" label="applicantname"
                            :reduce="applicant => applicant.applicantid" placeholder="Select Applicant"
                            class="input-box" :clearable="false" selectOnTab="True" />
                    </div>
                    <div class="form-group">
                        <label for="account">Account:</label>
                        <v-select v-model="formData.accountid" :options="accounts" label="accountname"
                            :reduce="account => account.accountid" placeholder="Select Account" class="input-box"
                            :clearable="false" selectOnTab="True" />
                    </div>
                    <div class="form-group">
                        <label for="fromdate">From Bill Date *</label>
                        <input type="text" id="fromdate" v-model="formData.fromdate" placeholder="dd/mm/yyyy"
                            v-on:blur="checkIsDate()" />
                    </div>
                    <div class="form-group">
                        <label for="todate">To Bill Date *</label>
                        <input type="text" id="todate" v-model="formData.todate" placeholder="dd/mm/yyyy"
                            v-on:blur="checkIsToDate()" />
                    </div>
                    <div class="form-group">
                        <button type="button" class="excel-button" @click="getReportDetails" :disabled="isSubmitting">Show Result</button>
                        <button type="button" class="cancel-button1">Cancel</button>
                    </div>
                </div>
                <div class="form-group2">
                    <fieldset style="padding:2px">
                        <legend>Update Bill PDF:</legend>
                        <input type="text" style="width:45%;float: left; margin-right: 10px;" v-model="billno" />
                        <button class="print-button" title="Print" style="width:45%;margin: 5px;"
                            @click="CreateBillPDF" :disabled="isSubmitting">
                            <i class="fas fa-print"></i>Re-generate
                        </button>
                    </fieldset>
                </div>
                <div class="form-group2">
                    <fieldset style="padding:2px">
                        <legend>Print Bill PDF:</legend>
                        <input type="text" style="width:45%;float: left; margin-right: 10px;" v-model="billno" />
                        <button class="print-button" title="Print" style="width:45%;margin: 5px;"
                            @click="reprintBillPDF" :disabled="isSubmitting">
                            <i class="fas fa-print"></i>Print
                        </button>
                    </fieldset>
                </div>
            </div>
        </div>
        <div class="table-container">
            <table class="port-table">
                <thead>
                    <tr>
                        <th>Bill No.</th>
                        <th>Report Date</th>
                        <th>Report No.</th>
                        <th>Applicant</th>
                        <th>Account</th>
                        <th colspan="2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="report in reports" :key="report.billno">
                        <td>{{ report.billno }}</td>
                        <td>{{ formatDate(report.billdate) }}</td>
                        <td>{{ report.reportno }}</td>
                        <td>{{ report.applicantname }}</td>
                        <td>{{ report.accountname }}</td>
                        <td>
                            <button v-if="report.filename" @click="printreport(report.filename)" class="pdf-button" :disabled="isSubmitting">
                                <i class="fas fa-file-pdf"></i> View PDF
                            </button>
                        </td>
                        <td>
                            <button @click="openEditModal(report.billno)" class="edit-button" :disabled="isSubmitting">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="isModalVisible" class="edit-overlay">
            <div class="edit-overlay-content">
                <span class="close-btn" @click="closeModal">&times;</span>
                <h2>Edit MIS bill</h2>
                <!-- Top Edit MIS Bill Section -->
                <div class="top-edit-section">
                    <!-- Left Side for Edit MIS Bill -->
                    <div class="left-side">
                        <!-- Form Fields -->
                        <div class="row first-row">
                            <div class="field">
                                <label for="date">Date:</label>
                                <input v-model="date" type="date" id="date" class="input-box" />
                            </div>
                            <div class="field">
                                <label for="applicant">Applicant:</label>
                                <v-select v-model="selectedApplicant" :options="applicants" label="applicantname"
                                    :reduce="applicant => applicant.applicantid" placeholder="Select Applicant"
                                    class="input-box" :clearable="false" selectOnTab="True" />
                            </div>
                            <div class="field">
                                <label for="account">Account:</label>
                                <v-select v-model="selectedAccount" :options="accounts" label="accountname"
                                    :reduce="account => account.accountid" placeholder="Select Account"
                                    class="input-box" :clearable="false" selectOnTab="True" />
                            </div>
                        </div>

                        <div class="row second-row">
                            <div class="field">
                                <label for="customer-ref">Customer Ref NO:</label>
                                <input v-model="customerRef" type="text" id="customer-ref" class="input-box" />
                            </div>
                            <div class="field checkbox-field center-checkbox">
                                <label for="report-in-bill">Report in BILL:</label>
                                <input v-model="reportInBill" type="checkbox" id="report-in-bill" />
                            </div>
                            <div class="field">
                                <label for="report-date">Report Date:</label>
                                <input v-model="reportDate" type="date" id="report-date" class="input-box" />
                            </div>
                            <div class="field checkbox-field center-checkbox">
                                <label for="round-off-checkbox">Round Off:</label>
                                <input v-model="roundOffChecked" type="checkbox" id="round-off-checkbox" />
                            </div>
                        </div>
                        <div class="">
                            <label for="particulars">Particulars:</label>
                            <!--<QuillEditor theme="snow" toolbar="essential" v-model:content="particulars"
                                content-type="html" />-->
                            <textarea v-model="particulars" ref="myTextarea" id="particulars" @keyup.enter="handleEnter" class="particulars-box"></textarea>
                        </div>
                        <hr class="separator" />

                        <div class="row non-gst-row">
                            <div class="field checkbox-field center-checkbox center-non">
                                <label for="non-gst-bill">Non-GST Bill:</label>
                                <input v-model="nonGstBill" type="checkbox" id="non-gst-bill" />
                                <label for="exp-bill">Exp Bill:</label>
                                <input v-model="isExpBill" type="checkbox" id="exp-bill" />
                            </div>
                        </div>

                        <!-- Product Details Table -->
                        <div class="table-section">
                            <h4>Product Details</h4>
                            <table class="details-table">
                                <thead>
                                    <tr>
                                        <th>Product Description</th>
                                        <th>Quantity</th>
                                        <th>Unit</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                        <th>CGST</th>
                                        <th>SGST</th>
                                        <th>IGST</th>
                                        <th>Item Total</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in productDetails" :key="index">
                                        <td>
                                            <select id="prodesc" v-model="item.productDescription"
                                                class="custom-select">
                                                <option value="0">Select Product</option>
                                                <option v-for="product in productOptions" :key="product.value"
                                                    :value="product.value">
                                                    {{ product.description }}
                                                </option>
                                            </select>
                                        </td>
                                        <td><input v-model.number="item.quantity" type="number" class="input-box" />
                                        </td>
                                        <td><input v-model="item.unit" type="text" class="input-box" /></td>
                                        <td><input v-model.number="item.rate" type="number" class="input-box"
                                                @keydown.tab="addRow(item,index)" @keyup.enter="addRow(item,index)" />
                                        </td>
                                        <td><input v-model.number="item.amount" type="text" readonly class="onlyread" />
                                        </td>
                                        <td><input v-model.number="item.cgst" type="text" readonly class="onlyread" />
                                        </td>
                                        <td><input v-model.number="item.sgst" type="text" readonly class="onlyread" />
                                        </td>
                                        <td><input v-model.number="item.igst" type="text" readonly class="onlyread" />
                                        </td>
                                        <td>{{ formatToTwoDecimal(calculateItemTotal(item)) }}</td>
                                        <td>
                                            <button v-if="productDetails.length > 1" @click="removeRow(index)"
                                                class="delete-btn">
                                                ✖
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Amount Summary Table -->
                        <div class="table-section">
                            <h4>Amount Summary</h4>
                            <table class="summary-table">
                                <thead>
                                    <tr>
                                        <th>Amount</th>
                                        <th>CGST</th>
                                        <th>SGST</th>
                                        <th>IGST</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ formatToTwoDecimal(totalAmount) }}</td>
                                        <td>{{ formatToTwoDecimal(totalCGST) }}</td>
                                        <td>{{ formatToTwoDecimal(totalSGST) }}</td>
                                        <td>{{ formatToTwoDecimal(totalIGST) }}</td>
                                        <td>{{ formatToTwoDecimal(totalSummary) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Final Details -->
                        <div class="row final-row">
                            <div class="field">
                                <label for="round-off-amount">Round Off:</label>
                                <div id="round-off-amount" class="readonly-value">{{ formatToTwoDecimal(roundOffAmount)
                                    }}</div>
                            </div>
                            <div class="field">
                                <label for="payable-amount">Payable Amount:</label>
                                <div id="payable-amount" class="readonly-value">{{ formatToTwoDecimal(payableAmount) }}
                                </div>
                            </div>
                        </div>

                        <!-- Save Button -->
                        <div class="save-button">
                            <button @click="saveReport" :disabled="isSubmitting">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
//import { QuillEditor } from '@vueup/vue-quill'
//import '@vueup/vue-quill/dist/vue-quill.snow.css'
//import '@vueup/vue-quill/dist/vue-quill.bubble.css';

export default {
    components: {
        VSelect,
        //QuillEditor
    },
    data() {
        return {
            billno: '',
            date: null,
            selectedApplicant: 0,
            selectedAccount: 0,
            customerRef: '',
            reportInBill: false,
            reportno: 0,
            particulars: '',
            reportDate: '',
            taxslab: 1,
            roundOffChecked: false, // Add this
            rndval: 0,
            payableamt: 0,
            nonGstBill: false,
            isExpBill: false,
            productDetails: [{ productDescription: 'Survey Fees', quantity: 0, unit: "Cntr", rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 }],
            productOptions: [
                { description: 'Survey Fees', value: 'Survey Fees' },
                { description: 'Travelling', value: 'Travelling' },
                { description: 'Misc Expenses', value: 'Misc Expenses' }
            ],
            isModalVisible: false, // Control visibility of the modal
            MisDbList: [],
            MisDbListDtl: [],
            usercompany: [],
            reports: [],
            accounts: JSON.parse(localStorage.getItem('accounts') || '[]'),
            applicants: JSON.parse(localStorage.getItem('applicants') || '[]'),
            isSubmitting: false,
            formData: {
                applicantid: 0,
                accountid: 0,
                fromdate: '',
                todate: '',
            },
        }
    },
    computed: {
        totalAmount() {
            return this.productDetails.reduce((sum, item) => sum + this.calculateAmount(item), 0);
        },
        totalCGST() {
            return this.productDetails.reduce((sum, item) => sum + item.cgst, 0);
        },
        totalSGST() {

            return this.productDetails.reduce((sum, item) => sum + item.sgst, 0);
        },
        totalIGST() {
            return this.productDetails.reduce((sum, item) => sum + item.igst, 0);
        },
        totalSummary() {
            return this.totalAmount + this.totalCGST + this.totalSGST + this.totalIGST;
        },
        payableAmount() {
            let amount = this.totalSummary;
            if (this.roundOffChecked) {
                amount = Math.round(amount);
            }
            return amount;
        },
        roundOffAmount() {
            let rndamount = 0
            let amount = this.totalSummary;
            if (this.roundOffChecked) {
                let roundedamt = Math.round(amount);
                rndamount = amount - roundedamt
            }
            return rndamount;
        }
    },
    methods: {
        handleEnter() {
            const cursorPosition = this.$refs.myTextarea.selectionStart;
            const start = this.particulars.substring(0, cursorPosition);
            const end = this.particulars.substring(cursorPosition);
            this.particulars = start + '<br>' + end;
        },
        formatDate(dateString) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return new Date(dateString).toLocaleDateString(undefined, options);
        },
        checkIsDate() {
            if (this.formData.fromdate != '') {
                if (cs.isvalidDate(this.formData.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.formData.todate != '') {
                if (cs.isvalidDate(this.formData.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        async getReportDetails() {
            if (this.isSubmitting) return;
            
            this.isSubmitting = true;
            this.isLoading = true;
            
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                };
                const transactionData = {
                    applicant: this.formData.applicantid,
                    account: this.formData.accountid,
                    fromdate: this.formData.fromdate,
                    todate: this.formData.todate
                }
                
                const response = await axios.get('/all_misbill?applicant=' + transactionData.applicant + '&account=' + transactionData.account + '&fromdate=' + transactionData.fromdate + '&todate=' + transactionData.todate, config);
                //console.log(response.data[1], response.data[2]);
                console.log(response)
                this.reports = response.data[2];
            } catch (error) {
                console.error('Error uploading file:', error);
                useToast().error(error.response?.data?.message || 'Error fetching report details.');
            } finally {
                this.isLoading = false;
                this.isSubmitting = false;
            }
        },
        async fetchReports() {
            this.reports = [];
            try {
                const token = localStorage.getItem('access_token');
                const response = await axios.get('/all_misbill', {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
                this.reports = response.data[2];
                console.log(response)
            } catch (error) {
                console.error('Error fetching reports:', error);
            }
        },
        async CreateBillPDF() {
            if (this.isSubmitting) return;
            
            const billno = this.billno
            if (!billno) {
                useToast().error('Please insert a bill number');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                };
                // Construct the URL with query parameters
                const url = `/CreateMISBillPDF?billno=${billno}`;
                // Send the GET request
                const response = await axios.get(url, config);
                console.log(response.data);
                if (response.data[0] == 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success('Created Succesful');
                    this.printreport(response.data);
                    //this.printBill(response.data);
                }
            } catch (error) {
                console.error('Error generating report:', error);
                useToast().error(error.response?.data?.message || 'Error generating PDF.');
            } finally {
                this.isSubmitting = false;
            }
        },
        async printreport(filename) {
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                };
                const urlpath = `/printmispdf?filename=${filename}`;
                console.log(urlpath)
                const response = await axios.get(urlpath, config);
                const pdfBlob = new Blob([response.data], { type: "application/pdf" });
                const url = URL.createObjectURL(pdfBlob);
                window.open(url);
            } catch (error) {
                console.error('Error generating report:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async getMisBillDetails(billno) {
            const token = localStorage.getItem('access_token');
            const config = {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
            try {
                const response = await axios.get('/getmisbilldetails?billno=' + billno, config);
                console.log(response);
                this.MisDbList = response.data[2][0][0];
                this.MisDbListDtl = response.data[2][1];
                const mishead = response.data[2][0][0];
                const misdtlx = response.data[2][1];


                console.log(mishead);
                console.log(misdtlx);
                this.date = mishead.billdate;
                console.log(this.date)
                this.billno = mishead.billno;
                this.selectedApplicant = mishead.applicantID;
                this.selectedAccount = mishead.accountID;
                this.customerRef = (mishead.custrefno == 'None' ? '' : mishead.custrefno);
                this.reportInBill = (mishead.isReport == 1 ? true : false);
                this.reportno = mishead.reportno;
                this.particulars = (mishead.particulars == 'None' ? '' : mishead.particulars);
                this.reportDate = mishead.reportdate;
                this.taxslab = mishead.taxslab;
                console.log(mishead.isRound)
                this.roundOffChecked = (mishead.isRound == 1 ? true : false); // Add this
                this.rndval = mishead.rndval;
                this.productDetails = misdtlx.map(item => ({
                    productDescription: item.billitem,
                    quantity: item.qty,
                    unit: item.unit,
                    rate: item.rate,
                    amount: item.amount,
                    sgst: item.sgst,
                    cgst: item.cgst,
                    igst: item.igst
                }));
                this.productDetails.push({ productDescription: 0, quantity: 0, unit: '', rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 });
                this.MisDbList = mishead;
                misdtlx.array.forEach(item => {
                    const misDtl = {
                        billitem: item.productDescription,
                        qty: item.quantity,
                        unit: (item.unit == 'None' ? '' : item.unit),
                        rate: item.rate,
                        amount: item.amount,
                        cgst: item.cgst,
                        sgst: item.sgst,
                        igst: item.igst
                    };
                    const index = this.MisDbListDtl.findIndex(misDtls => misDtls.billitem === misDtl.billitem && misDtls.unit === misDtl.unit)
                    //console.log(index);
                    if (index !== -1) {
                        this.MisDbListDtl.splice(index, 1, misDtl);
                    } else {
                        this.MisDbListDtl.push(misDtl);
                    }
                });
                //this.MisDbListDtl = misdtl;
            } catch (error) {
                console.error('Error fetching reports:', error);
            }
        },
        async openEditModal(billno) {
            console.log(billno)
            this.getMisBillDetails(billno);
            this.isModalVisible = true; // Show the modal
        },
        closeModal() {
            this.isModalVisible = false; // Hide the modal
        },
        calculateAmount(item) {
            return item.quantity * item.rate;
        },
        calculateItemTotal(item) {
            return item.amount + item.cgst + item.sgst + item.igst;
        },
        calculateAllAmount(item) {
            //console.log(this.usercompany);
            const selectedParty = this.applicants.find(app => app.applicantid === Number(this.selectedApplicant));
            //console.log(selectedParty)
            //console.log(selectedParty.state_id)
            item.amount = item.quantity * item.rate;
            item.igst = 0
            item.sgst = 0
            item.cgst = 0
            if (this.nonGstBill == false) {
                if (this.usercompany.state_id == selectedParty.state_id) {
                    this.taxslab = 2
                    item.cgst = Number(this.formatToTwoDecimal(item.amount * 0.09));
                    item.sgst = Number(this.formatToTwoDecimal(item.amount * 0.09));
                } else {
                    this.taxslab = 1
                    item.igst = Number(this.formatToTwoDecimal(item.amount * 0.18));
                }
            }
        },
        addRow(item,index) {
            console.log(item);
            if (item.productDescription == 0 || item.productDescription == '' || item.productDescription == null || item.quantity == 0 || item.rate == 0) {
                return;
            }
            this.calculateAllAmount(item)
            const misDtl = {
                billitem: item.productDescription,
                qty: item.quantity,
                unit: item.unit,
                rate: item.rate,
                amount: item.amount,
                cgst: item.cgst,
                sgst: item.sgst,
                igst: item.igst
            };

            //const index = this.MisDbListDtl.findIndex(misDtls => misDtls.billitem === misDtl.billitem && misDtls.unit === misDtl.unit && misDtls.qty === misDtl.qty && misDtls.rate === misDtl.rate)
            //console.log(index);
            //if (index !== -1) {
            //    this.MisDbListDtl.splice(index, 1, misDtl);
            //} else {
            //    this.MisDbListDtl.push(misDtl);
            //}
            this.MisDbListDtl.splice(index, 1);
            this.MisDbListDtl.push(misDtl);
            this.productDetails.push({ productDescription: 0, quantity: 0, unit: '', rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 });
            //document.getElementById('prodesc').focus();
        },
        removeRow(index) {
            if (this.productDetails.length > 1) {
                this.productDetails.splice(index, 1);
                this.MisDbListDtl.splice(index, 1);
            }
        },
        formatToTwoDecimal(value) {
            return value.toFixed(2);
        },
        async saveReport() {
            if (this.isSubmitting) return;
            
            if (this.billno == '') {
                useToast().error('Something goes wrong, please refresh the page');
                return;
            }
            if (!this.selectedApplicant) {
                useToast().error('Please select an applicant');
                return;
            }
            if (!this.date) {
                useToast().error('Please select a date');
                return;
            }
            if (this.reportInBill == true && !this.reportDate) {
                useToast().error('Please select a report date');
                return;
            }
            if (this.MisDbListDtl.length == 0) {
                useToast().error('Please add at least one product detail');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                // Add your save logic here
                //console.log('Report saved');
                this.MisDbList = [];
                const selectedParty = this.applicants.find(app => app.applicantid === Number(this.selectedApplicant));
                const misMast = {
                    billno: this.billno,
                    applicantID: this.selectedApplicant,
                    accountID: this.selectedAccount,
                    state_id: selectedParty.state_id,
                    billdate: this.date,
                    custrefno: this.customerRef,
                    isReport: this.reportInBill,
                    reportno: this.reportno,
                    reportdate: this.reportInBill == false ? null : this.reportDate,
                    isRound: this.roundOffChecked,
                    rndval: this.roundOffAmount,
                    payableamt: this.payableAmount,
                    nonGstBill: this.nonGstBill,
                    particulars: this.particulars,
                    taxslab: this.taxslab,
                    isExpBill: this.isExpBill,
                };
                console.log(this.particulars)
                this.MisDbList.push(misMast);
                const mismaster = JSON.stringify(this.MisDbList)
                console.log(mismaster);

                const misdtls = JSON.stringify(this.MisDbListDtl)
                console.log(misdtls);
                const data = new FormData();
                data.append('mismaster', mismaster)
                data.append('misdetail', misdtls)
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    },
                };
                const response = await axios.post('/updatemisbill', data, config);
                console.log(response);
                if (response.data[0] === 0) {
                    // Display success message using the second element of the response
                    useToast().error(response.data[1]);
                } else {
                    useToast().success('Created Succesful');
                    this.resetentry();
                    this.isModalVisible = false; // Show the modal
                    this.printreport(response.data[2]);
                    //console.log(this.successfulTasks, 'hello')
                }
            } catch (error) {
                console.error('Error saving report:', error);
                useToast().error(error.response?.data?.message || 'Error saving report.');
            } finally {
                this.isSubmitting = false;
            }
        },
        resetentry() {
            this.billno = '';
            this.date = '';
            this.selectedApplicant = null;
            this.selectedAccount = null;
            this.customerRef = '';
            this.reportInBill = false;
            this.particulars = '';
            this.reportDate = '';
            this.reportno = 0;
            this.taxslab = 1;
            this.roundOffChecked = false; // Add this
            this.rndval = 0;
            this.payableamt = 0;
            this.nonGstBill = false;
            this.isExpBill = false;
            this.productDetails = [{ productDescription: '', quantity: 0, unit: '', rate: 0, amount: 0, sgst: 0, cgst: 0, igst: 0 }];
            this.MisDbList = [];
            this.MisDbListDtl = [];
            this.content = ""
        },
    }, created() {
        this.usercompany = JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
        this.fetchReports();
    }
}
</script>
<style scoped>
.ql-container ql-snow {
    background: white;
    height: 200px;
}

.page-container {
    margin-left: 20px;
    /* Adjust as needed */
}

.name {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.top-edit-section {
    border: 1px solid #ddd;
    padding: 20px;
}

.row {
    display: flex;
    margin-bottom: 10px;
}

.field {
    margin-right: 20px;
    flex: 1;
}

.first-row .field,
.second-row .field {
    flex: 1;
}

.checkbox-field {
    display: flex;
    align-items: center;
}

.center-checkbox {
    text-align: center;
    flex: 1;
}

.input-box,
.particulars-box {
    width: 100%;
}

.particulars-box {
    min-height: 100px;
}

.separator {
    margin: 20px 0;
}

.table-section {
    margin-top: 20px;
}

.details-table,
.summary-table {
    width: 100%;
    border-collapse: collapse;
}

.center-non {
    margin-left: 45%;
}

.details-table th,
.details-table td,
.summary-table th,
.summary-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}

.delete-btn {
    background: none;
    border: none;
    color: red;
    cursor: pointer;
}

.readonly-value {
    font-weight: bold;
}

.save-button {
    margin-top: 20px;
    text-align: center;
}

.save-button button {
    padding: 10px 20px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.save-button button:hover {
    background-color: #0056b3;
}

/* Additional styles for proper alignment */
.final-row {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    /* Align the fields vertically */
    align-items: flex-end;
    /* Align fields to the right side */
    gap: 20px;
    /* Space between fields */
}

.field {
    display: flex;
    flex-direction: row;
    /* Align label and value horizontally */
    align-items: center;
    /* Center items vertically */
}

.field label {
    margin-right: 10px;
    /* Space between label and value */
}

.readonly-value {
    font-size: 16px;
    /* Adjust font size as needed */
    font-weight: bold;
    /* Optional: Make the value bold */
}

.onlyread {
    width: 100px;
    background: transparent;
}

.transaction-list {
    padding: 5px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 14px;
    color: #333;
}

.row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;

}

.container {
    width: 100%;
    background: #fff;
    padding: 5px 20px 5px 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-group {
    margin-bottom: 5px;
    width: 22%;
    padding: 5px;
    float: left;
}

.form-group2 {
    margin-bottom: 5px;
    width: 31%;
    padding: 5px;
    float: left;
}

label {
    display: block;
    margin-bottom: 5px;
}

.excel-button,
.generate-button,
.cancel-button1 {
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled,
.generate-button:disabled,
.cancel-button1:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.print-button:disabled,
.pdf-button:disabled,
.edit-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.save-button button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.excel-button {
    background-color: #17a2b8;
}

.cancel-button1 {
    background-color: #dc3545;
}

.print-button {
    background-color: rgb(50, 89, 187);
    color: white;
    border: none;
    padding: 8px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.print-button:hover {
    background-color: rgb(61, 146, 231);
}

/* Overlay container */
.edit-overlay {
    position: fixed;
    /* Ensures the overlay stays above all other content */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    /* Enables scrolling if the content exceeds viewport height */
    z-index: 9999;
    /* Ensures it appears above all other content */
}

/* Overlay content */
.edit-overlay-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    /* Adjusted width for better fit */
    /*max-width: 1000px;*/
    /* Adjusted max-width */
    max-height: 90vh;
    /* Limits the height to prevent overflow */
    overflow-y: auto;
    /* Enables vertical scrolling within the content */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-top: 50px;
    /* Adds margin from the top */
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
    color: #333;
}
</style>